import setCookie from '@stencil/flights-utils/src/set-cookie';
import getCookie from '@stencil/flights-utils/src/get-cookie';
import { assignVariant } from '@ibibo/pokus-apis';
import { setExperimentDetails, setExperimentMetaData } from '../SRP/redux/actions';
import { EMPTY_STRING, ADULT, CHILD, INFANT } from '@stencil/flights-constants';

export const getUniqueId = (key = 'gi_flt_identity') => {
  const val = getCookie(key);
  if (!val) {
    const cookieVal = new Date().getTime();
    setCookie(key, cookieVal, '', '/', window.location.host.replace('www.', ''), '');
    return cookieVal;
  }
  return val;
};

export const getPDTDetails = (fareIdentifier, fareOptionsInfo) => {
  if (fareIdentifier && fareOptionsInfo) {
    const fareOptions = Object.values(fareOptionsInfo);
    const fare = [].concat.apply([], fareOptions);
    const fareDetails = fare.find(o => o['identifier'] == fareIdentifier);
    return fareDetails;
  }
};

export const getPokusExperimentDetails = expName => {
  return async (dispatch, getState) => {
    try {
      const params = {
        attributes: {
          expName
        },
        lob: 'FLIGHT',
        user: {
          deviceId: getUniqueId()
        }
      };
      const response: any = await assignVariant(params);
      if (response) {
        dispatch(
          setExperimentDetails(response?.perLobMap?.FLIGHT?.exp_experiment_details_list || [])
        );
        dispatch(
          setExperimentMetaData({ [expName]: response?.perLobMap?.FLIGHT?.metadataValues || {} })
        );
      }
    } catch (ex) {}
  };
};

export const getPassengersText = passengers => {
  let txt = `${passengers.adult} ${ADULT}${passengers.adult > 1 ? 's' : EMPTY_STRING}`;
  if (passengers.child) {
    txt += ` ${passengers.child} ${CHILD}${passengers.child > 1 ? 'ren' : EMPTY_STRING}`;
  }
  if (passengers.infant) {
    txt += ` ${passengers.infant} ${INFANT}${passengers.infant > 1 ? 's' : EMPTY_STRING}`;
  }
  return txt;
};

export const getDateFromYYYYMMDDString = dateInYYYYMMDD => {
  const newDate = new Date(
    dateInYYYYMMDD.substring(0, 4),
    dateInYYYYMMDD.substring(4, 6) - 1,
    dateInYYYYMMDD.substring(6, 8)
  );
  return newDate;
};

const fallbackCopyTextToClipboard = text => {
  try {
    var textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
  } catch (ex) {
    throw ex;
  } finally {
    document.body.removeChild(textArea);
  }
};

export const copyTextToClipboard = async text => {
  try {
    if (!navigator.clipboard) {
      return fallbackCopyTextToClipboard(text);
    }
    return navigator.clipboard.writeText(text);
  } catch (ex) {
    throw ex;
  }
};

export const getGroundUpRepriceReqDetails = (
  query,
  experimentMetaData,
  onwardSelectedFlight,
  returnSelectedFlight = null
) => {
  const rid = query?.search_id;
  const fareBreakupVersion =
    experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

  const flight = {};
  let onwardFlightKey = '',
    onwardFlightVal = '',
    returnFlightKey = '',
    returnFlightVal = '';
  if (onwardSelectedFlight && onwardSelectedFlight.id) {
    onwardFlightKey = Object.keys(onwardSelectedFlight?.id)[0];
    onwardFlightVal = Object.values(onwardSelectedFlight?.id)[0][0];
  }
  if (onwardFlightKey && onwardFlightKey) flight[onwardFlightKey] = onwardFlightVal;

  if (returnSelectedFlight && returnSelectedFlight.id) {
    returnFlightKey = Object.keys(returnSelectedFlight?.id)[0];
    returnFlightVal = Object.values(returnSelectedFlight?.id)[0][0];
  }
  if (returnFlightKey && returnFlightVal) flight[returnFlightKey] = returnFlightVal;

  return {
    v: fareBreakupVersion ? 1.6 : 1.5,
    rid,
    rcoms: flight
  };
};

export const shouldFareOptionCardBeDisplayed = (
  fareOptionData,
  flavour,
  flightClass,
  paxCounts,
  travelType,
  journeyType
) => {
  // check if details are available
  const details = fareOptionData.details;
  if (!details || Object.keys(details).length === 0) {
    return false;
  }
  // check flavour
  if (!fareOptionData?.flavour?.includes(flavour)) {
    return false;
  }

  // check Class
  if (!fareOptionData?.fare_class?.includes(flightClass?.name?.toLowerCase() || '')) {
    return false;
  }

  // check pax count limit
  const paxProfile = fareOptionData?.paxProfile;
  if (
    paxCounts.adult > paxProfile.adult ||
    paxCounts.child > (paxProfile.child || 0) ||
    paxCounts.infant > (paxProfile.infant || 0)
  ) {
    return false;
  }

  // check travel type
  if (!fareOptionData?.trip_sector?.includes(travelType?.toLowerCase() || '')) {
    return false;
  }

  // check journey type
  if (!fareOptionData?.trip_type?.includes(journeyType?.toLowerCase() || '')) {
    return false;
  }

  return true;
};
